<template>
    <ul v-if="planFeatures" class="plan-features">
        <li
            v-for="feature in planFeatures"
            :key="feature.key"
            :class="getPlanFeatureClass(feature)"
        >
            {{ getPlanFeature(feature) }}
        </li>
    </ul>
    <base-loader v-else />
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        features: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        ...mapState(['planFeatures']),
    },

    methods: {
        /**
         * Returns plan feature class.
         *
         * @param {object} feature Feature object.
         * @returns {object} Object with classnames.
         */
        getPlanFeatureClass(feature) {
            const hasFeature = feature.key
                ? this.features.includes(feature.key)
                : !! feature.find(({ key }) => this.features.includes(key));

            return {
                'plan-feature': true,
                enabled: hasFeature,
                disabled: ! hasFeature,
            };
        },

        /**
         * Returns plan feature class.
         *
         * @param {object} feature Feature object.
         * @returns {string} Feature description.
         */
        getPlanFeature(feature) {
            return feature.description
                ? feature.description
                : feature.find(({ key }) =>
                    !! this.features.includes(key))?.description ||
                    feature[0]?.description;
        },
    },
};
</script>
